import { Text } from '@lmc/ui-kit/src/general'
import { Tooltip } from 'antd'
import { theme } from '@lmc/ui-kit'
import styled from 'styled-components'

type EditTooltipProps = {
  children: JSX.Element
  title: string
  testId?: string
}

export const EditTooltip = ({ children, title, testId }: EditTooltipProps) => (
  <Tooltip
    color={theme.color.neutral.color3}
    placement="topLeft"
    title={<TooltipTitle>{title}</TooltipTitle>}
    data-testid={testId ? `${testId}-edit-tooltip` : 'edit-tooltip'}
  >
    {children}
  </Tooltip>
)

export const TooltipTitle = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color11};
`
